// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useHolderServiceRequests } from '@hooks/queries/registry/onboarding/useHolderServiceRequests';
import { HolderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Holder';
import { useParties } from '../../contexts/PartiesContext';
import TemplateContract from '../../utils/TemplateContract';

export const useInboundHolderServiceRequests = () => {
  const { party } = useParties();
  const transform = (data: TemplateContract<HolderServiceRequest>[]) => {
    return data.filter((r) => r.payload.provider === party).length;
  };
  return useHolderServiceRequests(transform);
};
